import {
  PGA_COACH_CITY_LINKS,
  PGA_COACH_DEFAULT_CONTENT,
  PGA_COACH_PERSONAS,
  PGA_COACH_TRUST_PILLARS,
} from './constants'

const normalizeHeadline = (value = '') => value.trim().toLowerCase()

const mergePersonaCardsWithExperienceImages = (personas, experienceItems = []) => {
  if (!experienceItems.length) return personas

  const experienceByHeadline = experienceItems.reduce((map, item) => {
    const key = normalizeHeadline(item?.headline)
    if (!key || map.has(key)) return map
    map.set(key, item)
    return map
  }, new Map())
  const mappedPersonas = personas.map((persona) => ({
    ...persona,
    offeringCards: persona.offeringCards.map((card) => {
      const matchingExperience = experienceByHeadline.get(normalizeHeadline(card.title))
      return {
        ...card,
        imageUrl: matchingExperience?.media?.url || card.imageUrl,
        imageAlt: matchingExperience?.media?.description || card.imageAlt || card.title,
        link: matchingExperience?.link || card.link,
      }
    }),
  }))

  return mappedPersonas
}

export const buildPgaCoachJourneyContent = (entry = {}) => {
  const experiences = entry.coachExperiencesElementsCollection?.items
    || entry.personaSegmentCardsCollection?.items
    || []
  return {
    headline: entry.headline || PGA_COACH_DEFAULT_CONTENT.headline,
    subheadline: entry.subtitle || entry.subheadline || PGA_COACH_DEFAULT_CONTENT.subheadline,
    metaTitle: entry.metaTitle || `${PGA_COACH_DEFAULT_CONTENT.headline} | PGA Coach`,
    metaDescription: entry.metaDescription || PGA_COACH_DEFAULT_CONTENT.subheadline,
    metaImage: entry.metaImage,
    personas: mergePersonaCardsWithExperienceImages(PGA_COACH_PERSONAS, experiences),
    personaSectionSummary: entry.personaSegmentText || PGA_COACH_DEFAULT_CONTENT.personaSectionSummary,
    coachRailHeadline: PGA_COACH_DEFAULT_CONTENT.coachRailHeadline,
    coachRailSummary: PGA_COACH_DEFAULT_CONTENT.coachRailSummary,
    trustHeadline: PGA_COACH_DEFAULT_CONTENT.trustHeadline,
    trustSummary: PGA_COACH_DEFAULT_CONTENT.trustSummary,
    trustPillars: PGA_COACH_TRUST_PILLARS,
    guidesHeadline: entry.relatedArticlesTitle || PGA_COACH_DEFAULT_CONTENT.guidesHeadline,
    guidesSummary: entry.relatedArticlesText || PGA_COACH_DEFAULT_CONTENT.guidesSummary,
    guidesCta: entry.relatedArticlesCta || PGA_COACH_DEFAULT_CONTENT.guidesCta,
    guidesItems: entry.relatedArticlesCollection?.items || [],
    citySectionHeadline: PGA_COACH_DEFAULT_CONTENT.citySectionHeadline,
    citySectionSummary: PGA_COACH_DEFAULT_CONTENT.citySectionSummary,
    citySectionCta: PGA_COACH_DEFAULT_CONTENT.citySectionCta,
    cityLinks: PGA_COACH_CITY_LINKS,
    testimonialsSection: entry.testimonialsSection || null,
    viewAllCoachesLabel: PGA_COACH_DEFAULT_CONTENT.viewAllCoachesLabel,
  }
}

export default buildPgaCoachJourneyContent
